import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Certification } from '../certification';
import { ItemMaster } from '../item-master';

export interface YarnSearchRequest {
  code?: string;
  longDescription?: string;
  statuses?: number[];
}

export interface YarnSearchSeveralRequest {
  code: string;
  dataBaseName: string;
}

export interface YarnFormGroup {
  yarnType: FormControl<number | null>;
  yarnCount: FormControl<number | null>;
  stapleProperties: FormGroup<{
    ply: FormControl<number | null>;
    fiberProcessingMethodCode: FormControl<string | null>;
    stapleYarnProcessingMethodCode: FormControl<string | null>;
    yarnEffectCode: FormControl<string | null>;
    yarnEndUseCode: FormControl<string | null>;
  }>;
  filamentProperties: FormGroup<{
    filamentYarnProcessingMethodCode: FormControl<string | null>;
    numberOfFilaments: FormControl<number | null>;
    yarnLusterCode: FormControl<string | null>;
    yarnInterlacingLevelCode: FormControl<string | null>;
  }>;
  compositions: FormArray<
    FormGroup<{
      compositionCode: FormControl<string | null>;
      percentage: FormControl<number | null>;
    }>
  >;
}

export interface Yarn {
  id?: string;
  code?: string;
  yarnCount: number;
  yarnComposition: YarnComposition[];
  longDescription: string;
  yarnType: number;
  stapleProperties?: StapleProperties;
  filamentProperties?: FilamentProperties;
  status: number;
}

export interface StapleProperties {
  ply: number;
  fiberProcessingMethodCode: string;
  stapleYarnProcessingMethodCode: string;
  yarnEffectCode?: string;
  yarnEndUseCode?: string;
}

export interface FilamentProperties {
  filamentYarnProcessingMethodCode?: string;
  numberOfFilaments: number;
  yarnLusterCode?: string;
  yarnInterlacingLevelCode?: string;
}

export interface YarnComposition {
  compositionCode: string;
  percentage: number;
}

export enum YarnType {
  Filament,
  Staple,
}

export interface YarnCodeWithCertAndItemMaster {
  yarnCode: string;
  certifications: Certification[];
  itemMaster: ItemMaster | null;
}

export interface MatchingItemMasterCommand {
  yarnCode: string;
  certificationReference?: string[];
}

export interface YarnSearchForm {
  code?: FormControl<string | null>;
  longDescription?: FormControl<string | null>;
  statuses?: FormControl<number[] | null>;
}
